import React, { useEffect, useState } from "react";
import { useBeneficiariesStore } from "../../../config/stores";
import BeneficiariesTable from "./ManageBeneficiaries/BeneficiariesTable";
import BeneficiaryForm from "./ManageBeneficiaries/BeneficiaryForm";
import BeneficiaryDetails from "./ManageBeneficiaries/BeneficiaryDetails";
import { useDispatch } from "react-redux";
import projectThunks from "../../../config/thunks/businessDevAndPartnerships/projects/projects.thunks";
import { Col, Row } from "antd";
import DashboardCard from "../../home/DashboardCard";
import { FcConferenceCall, FcBusinessman, FcBusinesswoman, FcGlobe, FcHome } from "react-icons/fc";
import { FaWheelchair } from "react-icons/fa";

const Beneficiaries = () => {
  const beneficiariesStore = useBeneficiariesStore();
  const dispatch = useDispatch();
  const data = beneficiariesStore.beneficiaries || [];
  const [filteredData, setFilteredData] = useState(null);

  const displayed = filteredData !== null ? filteredData : data;

  const total   = displayed.length;
  const male    = displayed.filter((b) => String(b.gender || "").toLowerCase() === "male").length;
  const female  = displayed.filter((b) => String(b.gender || "").toLowerCase() === "female").length;
  const ugandan = displayed.filter((b) => b.nationality === "UGANDAN").length;
  const refugee = displayed.filter((b) => b.nationality === "REFUGEE").length;
  const pwd     = displayed.filter((b) => b.disability_status === true || b.disability_status === "true").length;

  useEffect(() => {
    beneficiariesStore.getBeneficiaries();
    dispatch(projectThunks.getProjects());
  }, []);

  // Reset filtered data when full data reloads
  useEffect(() => {
    setFilteredData(null);
  }, [data.length]);

  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold">BENEFICIARIES</h5>
      <Row gutter={[8, 8]} className="mb-3">
        <Col xs={12} sm={8} md={4}>
          <DashboardCard title="Total Beneficiaries" value={total} icon={<FcConferenceCall size={24} />} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <DashboardCard title="Male" value={male} icon={<FcBusinessman size={24} />} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <DashboardCard title="Female" value={female} icon={<FcBusinesswoman size={24} />} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <DashboardCard title="Ugandan" value={ugandan} icon={<FcHome size={24} />} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <DashboardCard title="Refugee" value={refugee} icon={<FcGlobe size={24} />} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <DashboardCard title="People with Disabilities" value={pwd} icon={<FaWheelchair size={24} color="#1890ff" />} />
        </Col>
      </Row>
      <BeneficiariesTable onFilteredDataChange={setFilteredData} />
      <BeneficiaryForm />
      <BeneficiaryDetails />
    </div>
  );
};

export default Beneficiaries;
